const FilterInput = '.js-blog-filter-input';
const FilterInputChecked = '.js-blog-filter-input:checked';
const FilterReset = '.js-blog-filter-reset';
const FilterSort = '.js-blog-filter-sort:visible';
const FilterSortMob = '.js-blog-filter-sort-mob';
const LoadMore = '.js-blog-load-more';
const FilterMobCount = '.js-filter-mob-count';
const FilterLabels = '.js-blog-filter-label';


function BlogFilter() {
	$( FilterInput + ',' + FilterSort ).on('change', function(event){
		var tag_ids = BlogFilterGetTags();
		var sortBy = BlogFilterGetSort();

        if( $( FilterInputChecked+":visible" ).length == 0 ) {
            $( FilterReset ).prop( "checked", true );
        } else {
            $( FilterReset ).prop( "checked", false );
        }

		BlogFilterAjax( tag_ids, sortBy );
        BlogFilterUpdateMobCount();
	});

    $( FilterReset ).on('click', function(){
		var sortBy = BlogFilterGetSort();

        $(this).prop( "checked", true );

        $( FilterInputChecked ).each(function(){
			$(this).prop( "checked", false );
		});

        BlogFilterAjax( '', sortBy );
        BlogFilterUpdateMobCount();
    });

    $( LoadMore ).on('click', function(){
        var tag_ids = BlogFilterGetTags();
		var sortBy = BlogFilterGetSort();
		var exclude = BlogFilterGetExcluded();

        BlogFilterAjax( tag_ids, sortBy, exclude );
        BlogFilterUpdateMobCount();
    });

    $( FilterSortMob ).on('change', function(){
        $( FilterSortMob + ':visible' ).each(function(){
			$(this).prop( "checked", false );
		});

        $(this).prop( "checked", true );

        var tag_ids = BlogFilterGetTags();
		var sortBy = BlogFilterGetSort();

        BlogFilterAjax( tag_ids, sortBy );
        BlogFilterUpdateMobCount();
    });

    ResizeReloadPage();
    BlogFilterUpdateMobCount();
    BlogFilterByUrl();

}

function ResizeReloadPage() {
    var width = $(window).width();
    var screen = "";

    if(width <= 767 ){
        screen = "mobile";
    } else if( width > 767 ) { 
        screen = "desktop";
    }

    $(window).resize(function(){
        var cur_width = $(window).width();

        if(cur_width < 767 && screen == "desktop"){
            location.reload(); 
        } else if(cur_width > 767 && screen == "mobile"){
            location.reload();
        }
    });
}

function BlogFilterGetTags() {
    var tag_ids = '';
    var tag_count = 0;

    $( FilterInputChecked ).each(function(){
        var id = $(this).data('id');

        if( id == undefined ) {
            return true;
        }

        if( tag_count !== 0 ) {
            tag_ids += ',';
        }

        tag_ids += id;

        tag_count++;
    });

    return tag_ids;
}

function BlogFilterGetExcluded() {
    var exclude_ids = '';
    var exclude_count = 0;

    $('.js-blog-post').each(function(){
        var id = $(this).data('id');

        if( id == undefined ) {
            return true;
        }

        if( exclude_count !== 0 ) {
            exclude_ids += ',';
        }

        exclude_ids += id;
        exclude_count++;
    });

    return exclude_ids;
}

function BlogFilterGetSort() {
    if( $(FilterSort).length == 0 && $(FilterSortMob + ":visible").length == 0 ) {
        return '';
    }

    if ( $(FilterSort).length ) {
        return $(FilterSort).val();
    }

    if ( $(FilterSortMob + ":visible").length ) {
        var value = $(FilterSortMob + ':checked').val();

        if( value !== undefined ) {
            return value;
        } else {
            return '';
        }
    }
}

function BlogFilterUpdateMobCount() {
    var count = jQuery('.js-filter-mixit-menu input[type="checkbox" ]:checked').length;

    if( count > 0 ) {
        $(FilterMobCount).text( '(' + count  +')' );
    }
}

function BlogFilterByUrl() {
    var parts = window.location.search.substr(1).split("&");
    var $ulr_param = {};

    for (var i = 0; i < parts.length; i++) {
        var temp = parts[i].split("=");
        $ulr_param[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    }
    
    var labels = jQuery(FilterLabels + ':contains(' + $ulr_param['filter-by'] + ')');
    
    if( labels.length == 0 ) {
        return;
    }

    // Remove Reset Button
    $( FilterReset ).prop( "checked", false );

    // Select Tags from URL
    for (var i = 0; i < labels.length; i++) {
        var input_ids = $(labels[i]).attr('for');
        $('#' + input_ids).prop( "checked", true );
    }

    var tag_ids = BlogFilterGetTags();
    var sortBy = BlogFilterGetSort();

    BlogFilterAjax( tag_ids, sortBy );
}

function BlogFilterAjax(tags = '', orderBy = '', exclude = '') {
    var posts_per_page = 5;

    if( exclude !== '' ) {
        posts_per_page = 20;
    }

    jQuery.ajax( {
        url: gocoderzAjax.url,
        type: "post",
        data: {
            action: "load_more_home_blog_posts_ajax",
            nonce: gocoderzAjax.nonce,
            'tags' : tags,
            'sort' : orderBy,
            'exclude' : exclude,
            'posts_per_page' : posts_per_page,
        },
        beforeSend: function() {
            $('.js-blog-filter-nav').addClass('blog-filter-nav-disabled');
            $('.js-blog-filter-nav').addClass('blog-filter-nav-disabled');
            $('.js-blog-articles-loading').addClass('is-visible');
            $(LoadMore).addClass('is-loading');
        },
        success: function ( response ) {
            var countPosts = $(response).filter('.js-blog-post').length;

            if( countPosts < posts_per_page ) {
                $('.js-blog-load-more').hide();
            } else {
                $('.js-blog-load-more').show();
            }

            if( exclude == '' ) {
                $('.js-blog-articles-wrap').html(response);
            } else {
                $('.js-blog-articles-wrap').append(response);
            }

            $('.js-blog-filter-nav').removeClass('blog-filter-nav-disabled');
            $('.js-blog-articles-loading').removeClass('is-visible');
            $(LoadMore).removeClass('is-loading');
        },
        error: function ( error ) {
            
        }
    } );
}

export { BlogFilter };